export default "__VITE_ASSET__89131d03__"